import { v4 as uuidv4 } from 'uuid';
import { getBucketUrlImageV2, uploadFileImage } from './uploadApi';

/**
 * Uploads a picked handover photo to a fresh temp slot and returns the URL the
 * handover endpoints move into place on submit.
 *
 * Kept out of the `@/utils` barrel: `uuid` is ESM-only, and every suite that
 * imports the barrel would have to mock it.
 */
export const uploadHandoverPhoto = async (
  file: { name: string; base64: string },
  type: 'vehicleHandover' | 'vehicleReturn' = 'vehicleHandover'
): Promise<string> => {
  const response = await getBucketUrlImageV2({ type, uuid: uuidv4() });
  const url = response?.data;
  const base64Data = file.base64?.split(',')[1];
  if (!url || !base64Data) throw new Error('Failed to get upload URL');
  const upload = await uploadFileImage(url, base64Data, file.name);
  if (upload.status !== 200) throw new Error('Upload failed');
  return url;
};
